import * as React from 'react';
import canCreateTaskInFolder from '../utils/canCreateTaskInFolder';
import Droppable from 'owa-dnd/lib/components/Droppable';
import getDropState from '../selectors/getDropState';
import getSelectedFolderView from '../selectors/getSelectedFolderView';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { dropMailItems } from '../actions/dropActions';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { observer } from 'mobx-react';

export interface TaskCreateDroppableProps {
    classNames?: string;
}

/**
 * This component handles creating a task from items dropped on it.
 * For now, that's creating a task from email messages.
 */
@observer
export default class TaskCreateDroppable extends React.Component<TaskCreateDroppableProps, {}> {
    render() {
        const dropViewState = getDropState();

        return (
            <Droppable
                dropViewState={dropViewState}
                canDrop={this.canDrop}
                onDrop={this.onDrop}
                classNames={this.props.classNames}
                greedy={true}>
                {this.props.children}
            </Droppable>
        );
    }

    private onDrop(dragData: DragData, pageX: number, pageY: number, target?: HTMLElement) {
        switch (dragData.itemType) {
            case DraggableItemTypes.MailListRow:
                const mailListDragData = dragData as MailListRowDragData;
                dropMailItems(mailListDragData, getSelectedFolderView().folderId);
                break;
        }
    }

    private canDrop(dragInfo: DragData): boolean {
        const folderView = getSelectedFolderView();
        const canAddTasks = folderView ? canCreateTaskInFolder(folderView.folderId) : false;

        /**
         * We need to add Todo to the types allowed to drop, otherwise we get the
         * no-drop-allowed effect when reordering tasks.
         */
        return (
            // If we are dragging an email item, then check whether we can actually create tasks in this folder.
            // If we are dragging a task item, allow reordering because that's the only view we support right now.
            (dragInfo.itemType === DraggableItemTypes.MailListRow && canAddTasks) ||
            dragInfo.itemType === DraggableItemTypes.Todo
        );
    }
}
